import firebase from 'firebase';

export const apiCalculateProgressGoals = firebase.functions().httpsCallable('progressGoalsStarter');
export const queryProgressGoals = firebase.functions().httpsCallable('queryApi');

export default 'progressGoals.api.js';
